import PropTypes from "prop-types";
import React from "react";

export default class SearchBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initiatedLoad: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.loading) {
      this.setState({ initiatedLoad: false });
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.handleEntry(this.keywordInput.value ? this.keywordInput.value.replaceAll("\"", "") : ""); 
    this.setState({ initiatedLoad: true });
  }

  render() {
    const { dictionary, keywords, loading } = this.props;
    const shouldShowSpinner = this.state.initiatedLoad && loading;
    return (
      <form
        className="search-box"
        onSubmit={(e) => this.handleSubmit(e)}
        noValidate
        role="search"
      >
        <div className="search-box__input">
          <label htmlFor="site-search" className="u-visuallyhidden">
            {dictionary.searchBoxLabel}
          </label>
          <input
            id="site-search"
            type="search"
            placeholder={dictionary.searchBoxPlaceholder}
            defaultValue={(keywords ? keywords.replaceAll("\"", "") : "") || ""}
            ref={(input) => (this.keywordInput = input)}
          />
          <button type="submit" className="search-box__button">
            <span className="u-visuallyhidden">Submit Search</span>
            <svg className="icon" role="img" aria-label="maginfying glass icon">
              <title>magnifying glass icon</title>
              <use xlinkHref="/assets/VelirSite-build/img/svg-sprite.svg#search"></use>
            </svg>
          </button>
        </div>
      </form>
    );
  }
}

const { string, func, shape, bool } = PropTypes;

SearchBox.propTypes = {
  keywords: string,
  handleEntry: func.isRequired,
  loading: bool,
  dictionary: shape({
    searchBoxPlaceholder: string,
    searchBoxLabel: string,
  }).isRequired,
};
